import { get_state } from "../../redux/State";
import { Keys } from "../../redux/Datastore";
import { Actions } from "../../redux/Actions";
export function draw_cluster_toggle_menu(): void {
    // if (!get_state().enabled_feature_cluster) {
    //     // clustering is not enabled. do nothing
    //     return;
    // }
    // mark the selected bulding
    let li: HTMLLIElement = <HTMLLIElement>document.getElementById("menu_cluster_toggle_content_list_item");
    let a: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById("cluster_menu_select");
    if (get_state().get_boolean(Keys.ENABLED_FEATURE_CLUSTER)) {
        a.text = "Clustering Enabled";
    }
    else {
        a.text = "Clustering Disabled";
    }
}
export function remove_cluster_menu_item(): void {
    let div: HTMLDivElement = <HTMLDivElement>document.getElementById("menu_cluster_content1");
    if (div) {
        div.style.display = "none";
    }
}
export function show_cluster_menu_item(): void {
    let div: HTMLDivElement = <HTMLDivElement>document.getElementById("menu_cluster_content1");
    if (div) {
        div.style.display = "block";
    }
}
export function toggle_clustering(dispatch: any): void {
    let enabled: boolean = true;
    let anchor: HTMLAnchorElement = <HTMLAnchorElement>document.getElementById('cluster_menu_select');
    let li: HTMLLIElement = <HTMLLIElement>document.getElementById("menu_cluster_toggle_content_list_item");
    let selected_in_ui: boolean = li.classList.contains("selected");
    enabled = !selected_in_ui;
    
    if (enabled) {
        anchor.text = "Clustering Enabled";
        dispatch(Actions.ACTION_SET_CLUSTER_TOGGLE, true);
        li.classList.add("selected");
    }
    else {
        anchor.text = "Clustering Disabled";
        dispatch(Actions.ACTION_SET_CLUSTER_TOGGLE, false);
        li.classList.remove("selected");
    }
}